<div class="form-check">
  <input
    type="radio"
    class="form-check-input {{ props.cssClass }}"
    [id]="field.key"
    [name]="props.name"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [class.is-invalid]="hasValidation && invalid"
    [class.is-valid]="hasValidation && valid"
  />
  <label class="form-check-label" [for]="field.key">{{ props.label }}</label>
</div>
